import { useEffect, useState } from "react";
import { fetchPageContent } from "../api/contentApi";
import { useLang } from "../context/LangContext";
import bgImg from "../assets/translation_bg.jpg";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faHandshake,
  faFileSignature,
  faLock,
  faComments,
  faPhone
} from "@fortawesome/free-solid-svg-icons";
import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";
import "../styles/translation.css";

export default function Translation() {
  const [content, setContent] = useState({});
  const { lang } = useLang();

  useEffect(() => {
    fetchPageContent("translation", lang).then(data => setContent(data));
  }, [lang]);

  if (!content) return <p>Loading...</p>;
  return (
  <section className="translation-page">
      <div className="translation-bg"
        style={{ backgroundImage: `url(${bgImg})` }}>
      <div className="translation-overlay">
        {content.translation_title && ( 
      <h1 className="translation-title">{content.translation_title}</h1>
        )}
        {content.translation_about && ( 
      <h2 className="translation-intro">
        {content.translation_about}
      </h2>
        )}

    
      <div className="translation-grid">
        {content.translation_text_1 && ( 
        <div className="translation-card">
          <div className="translation-icon">
           <FontAwesomeIcon icon={faFileSignature} /> 
          </div>
          <p>{content.translation_text_1}</p>
        </div>
        )}  
        {content.translation_text_2 && ( 
        <div className="translation-card">
          <div className="translation-icon">
           <FontAwesomeIcon icon={faLock} />
          </div>
          <p>{content.translation_text_2}</p>
        </div>
        )}  
        {content.translation_text_3 && ( 
        <div className="translation-card">
          <div className="translation-icon">
            <FontAwesomeIcon icon={faHandshake} />
          </div>
          <p>{content.translation_text_3}</p>
        </div>
        )}

        {content.translation_text_4 && ( 
        <div className="translation-card">
          <div className="translation-icon">
           <FontAwesomeIcon icon={faComments} />
          </div>
          <p>{content.translation_text_4}</p>
        </div>
        )}

         {content.translation_text_5 && ( 
        <div className="translation-card">
          <p>{content.translation_text_5}</p>
        </div>
        )}

         {content.translation_text_6 && ( 
        <div className="translation-card">
          <p>{content.translation_text_6}</p>
        </div>
        )}
      </div>

        {content.translation_phone && (
        <div className="translation-bottom">
          <div className="translation-icon">
            <FontAwesomeIcon icon={faPhone} />
          </div>
          /
          <div className="translation-icon">
          <FontAwesomeIcon icon={faWhatsapp} />
          </div>
          <div>
         <a className="translation-contact" href={`tel:+${content.translation_phone}`}>
            + {content.translation_phone}
          </a>
          </div>
        </div>
        )}
       <div className="spacer"/>
       </div>
       </div>
    </section>

  );

};